import React from 'react';
import PropTypes from 'prop-types';
import ScrollContainer from '../../../../commonComponents/container/ScrollContainer';
import translate from '../../../../commonComponents/translate';
import ActivityNotesProp from '../../propTypes/activityNotesProp';
import ActivityNote from './ActivityNote';

function ActivityNotesList(props) {
  const { t, list, onReachEnd, hasEnded, isLoading } = props;

  return (
    <div
      className="list-container"
      style={{ '--list-height': `${(list?.length - 1) * 125}px` }}
    >
      <h3 className="title">{t('order.button.activity_notes')}</h3>
      {list?.length > 0 ? (
        <ScrollContainer
          onReachedEnd={onReachEnd}
          onReachedEndDelay={1500}
          containerClass={`list-wrapper ${
            hasEnded ? 'list-finished-container' : ''
          }`}
        >
          {list?.map(activity => (
            <ActivityNote
              key={`${activity.date}_${activity.type}`}
              activity={activity}
            />
          ))}
        </ScrollContainer>
      ) : (
        <span className="hint-form">
          {isLoading
            ? `${t('loading')}...`
            : t('opportunity.notes.list.zero.event')}
        </span>
      )}
    </div>
  );
}

ActivityNotesList.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape(ActivityNotesProp.propType)),
  onReachEnd: PropTypes.func.isRequired,
  hasEnded: PropTypes.bool,
  isLoading: PropTypes.bool,
};

ActivityNotesList.defaultProps = {
  list: [],
  hasEnded: true,
  isLoading: false,
};

export default translate(ActivityNotesList);
